import React from 'react';
import './Footer.css';
import { IMAGES } from '../../assets/image';
import { CREDIT_UNION } from '../../assets/constants';
const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="layout-container footer-container">
        <div className="footer-left">
          <img
            src={IMAGES.ACUTXLogo}
            alt="Equal Housing Lender Logo"
            className="footer-logo"
          />
        </div>
        <div className="footer-right">
          <h6>© 2025 {CREDIT_UNION.INFO.NAME}. All Rights Reserved.</h6>

          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
